import React from 'react';
import ActionButton from '../../builder/ActionButton';
import { getRemotedbUrl } from '../../../lib/ep';

const Linkedin = (props) => {
	const post = props?.post ?? null;
	if(props.url == undefined || props.img == undefined) return null;
	const share = props?.share ?? {};
	
	const click = () => {
		const linkable = props?.linkable ?? true;
		if(!linkable) return;

		const url = `https://www.linkedin.com/shareArticle?mini=true&url=${props.url}&summary=${post}`;
		window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');

		if(share.promotion_id != undefined) {
			$.post(getRemotedbUrl(`/users/sharebtn/${share.promotion_id}`), {
				network:9,
				page:share.page,
				type:share.type,
				uid:share?.user_id ?? null,
			});
		} else {
			return;
		}
	}

	return (
		<ActionButton
			{...props}
			icon='ep-linkedin is_linkedin'
			onClick={() => click()}
		/>
	);
}

export default Linkedin;